import script from "./github-app-steps.vue?vue&type=script&setup=true&lang=ts"
export * from "./github-app-steps.vue?vue&type=script&setup=true&lang=ts"

import "./github-app-steps.vue?vue&type=style&index=0&id=e9388acc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9388acc"]])

export default __exports__